<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title>{{ $t(type) }} {{ $t("entrepot") }}</v-toolbar-title>
      <v-radio-group v-model="type" class="mt-6" row>
        <v-radio
          :label="$t('tempReceipt')"
          value="tempReceipt"
          :disabled="
            (id && type != 'tempReceipt') || (type != 'receipt' && type != 'tempReceipt')
              ? true
              : false
          "
        />
        <v-radio
          :label="$t('receipt')"
          value="receipt"
          :disabled="
            (id && type != 'tempReceipt') || (type != 'receipt' && type != 'tempReceipt')
              ? true
              : false
          "
        />
        <v-radio
          :label="$t('remittance')"
          value="remittance"
          :disabled="id || type != 'remittance' ? true : false"
        />
        <v-radio
          :label="$t('useRemittance')"
          value="useRemittance"
          :disabled="id || type != 'useRemittance' ? true : false"
        />
        <v-radio
          :label="$t('transferRemittance')"
          value="transferRemittance"
          :disabled="id || type != 'transferRemittance' ? true : false"
        />
        <v-radio
          :label="$t('transferProductStock')"
          value="transferProductStock"
          :disabled="id || type != 'transferProductStock' ? true : false"
        />
        <v-radio
          :label="$t('warehouseHandling')"
          value="warehouseHandling"
          :disabled="id || type != 'warehouseHandling' ? true : false"
        />
      </v-radio-group>
      <v-spacer />
      <export-excel
        v-if="id"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="1"
        :page-prop="1"
        @getAllRows="getAllRows"
        :excelIndex="true"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" icon small class="float-left" v-on="on">
              <v-icon color="teal" style="font-size: 21px">
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("get-excel") }}</span>
        </v-tooltip>
      </export-excel>
      <!--  -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("newRow") }} (f2)</span>
      </v-tooltip>
      <v-tooltip v-if="selected.length > 0" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon color="pink" style="font-size: 22px"> mdi-trash-can-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon color="blue" style="font-size: 22px">
              {{
                showSelect ? "mdi-checkbox-blank-outline" : "mdi-checkbox-marked-outline"
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("select-row") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("list") }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-tabs class="entrepot-form-tabs">
        <v-tab>
          {{ $t("public-information") }}
        </v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab-item class="entrepot-main-tab" style="touch-action: none">
          <v-container class="py-0 px-1 entrepot-main-tab__body" fluid>
          <v-row class="mt-1 mb-2 mx-0 px-0 input-minimal">
            <v-col cols="12" sm="2" md="2" class="py-1 px-1">
              <autocomplete
                ref="refEntrepot"
                v-model="entrepot"
                :rules="[(v) => !!v || $t('is-required')]"
                :title="$t('entrepot')"
                type="entrepot"
                :set-init="true"
              />
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1 px-1">
              <autocomplete
                v-model="branch"
                :title="$t('branch')"
                type="branch"
                :set-init="true"
                :value="branch"
              />
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1 px-1">
              <template>
                <v-text-field
                  id="from"
                  v-model="date"
                  :label="$t('date')"
                  :rules="[(v) => !!v || $t('is-required')]"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                  class="mb-0"
                />
                <date-picker
                  v-model="date"
                  element="from"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="$store.state.startDate"
                  :max="$store.state.endDate"
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                  @close="setDate"
                />
              </template>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1 px-1">
              <status v-model="status" :hideconfig="true" :type="type" :value="status" />
            </v-col>
            <v-col
              v-if="type == 'receipt' || type == 'remittance' || type == 'tempReceipt'"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <autocomplete
                ref="refRelations"
                v-model="relations"
                :value="relations"
                :data="
                  JSON.stringify({
                    refId: null,
                    currency_id: null,
                    checkCount: true,
                    type: type,
                  })
                "
                :title="$t('relative-document')"
                type="getInvoiceForEntrepot"
              />
            </v-col>
            <v-col
              v-show="
                type === 'transferRemittance' ||
                type === 'transferProductStock' ||
                type === 'transferReceipt'
              "
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <autocomplete
                ref="refRecipientEntrepot"
                v-model="recipientEntrepot"
                :rules="[(v) => !!v || $t('is-required')]"
                :title="$t('recipientEntrepot')"
                type="entrepot"
                :data="JSON.stringify({ withoutAccess: true })"
                :set-init="true"
              />
            </v-col>
            <v-col
              v-show="
                type === 'transferRemittance' ||
                type === 'transferProductStock' ||
                type === 'transferReceipt'
              "
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <autocomplete
                v-model="recipientBranch"
                :title="$t('recipientBranch')"
                type="branch"
                :set-init="true"
                :value="recipientBranch"
                :data="JSON.stringify({ withoutAccess: true })"
              />
            </v-col>
            <!-- useRemittance: detail fills 5th slot before tag. -->
            <v-col
              v-if="type === 'useRemittance'"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <autocomplete
                ref="refDetail"
                v-model="detail"
                :rules="[(v) => !!v || $t('is-required')]"
                :title="$t('detail')"
                type="detail"
              />
            </v-col>
            <!-- Non-transfer: fill remaining first-row slot (transfer already has 6 fields). -->
            <v-col
              v-if="
                type !== 'transferRemittance' &&
                type !== 'transferProductStock' &&
                type !== 'transferReceipt'
              "
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <tag v-model="tag" :solo="false" :input="tag" :height="25" />
            </v-col>
            <!-- warehouseHandling has no 6th meta field: put search on row 1 to fill the grid. -->
            <v-col
              v-if="type === 'warehouseHandling'"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <v-text-field
                v-model="search"
                :label="$t('search')"
                outlined
                clearable
                dense
                hide-details
                class="mb-0"
              />
            </v-col>
          </v-row>
          <v-row class="mt-1 mb-1 mx-0 px-0 input-minimal">
            <v-col
              v-if="
                type === 'transferRemittance' ||
                type === 'transferProductStock' ||
                type === 'transferReceipt'
              "
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <tag v-model="tag" :solo="false" :input="tag" :height="25" />
            </v-col>
            <v-col
              v-if="type !== 'warehouseHandling'"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
            >
              <v-text-field
                v-model="search"
                :label="$t('search')"
                outlined
                clearable
                dense
                hide-details
                class="mb-0"
              />
            </v-col>
            <v-col
              cols="12"
              :sm="
                type === 'transferRemittance' ||
                type === 'transferProductStock' ||
                type === 'transferReceipt'
                  ? 8
                  : type === 'warehouseHandling'
                  ? 12
                  : 10
              "
              :md="
                type === 'transferRemittance' ||
                type === 'transferProductStock' ||
                type === 'transferReceipt'
                  ? 8
                  : type === 'warehouseHandling'
                  ? 12
                  : 10
              "
              class="py-1 px-1 entrepot-desc-col"
            >
              <description
                ref="refContent"
                v-model="content"
                class="mb-0 entrepot-desc-field"
                height="28"
                :outlined="true"
                type="purchase"
              />
            </v-col>
          </v-row>
          <v-row class="mt-1 mx-0 entrepot-main-tab__table-row">
            <v-col
              cols="12"
              class="px-1 py-0 mb-0 pb-0 border-datatable entrepot-main-tab__table-col"
            >
              <v-data-table
                v-if="headers"
                :height="tableHeightEntrepot"
                fixed-header
                v-model="selected"
                v-column-resize="entrepotColumnPlugins"
                v-column-drag="entrepotColumnPlugins"
                v-column-pin="entrepotColumnPlugins"
                :headers="showHeaders"
                :items="filteredItems"
                :options.sync="tableOptions"
                :server-items-length="totalItems"
                :loading="loading"
                multi-sort
                class="main-table invoice-sell-table-scroll"
                style="border-left: 1px solid #e3e3e3; border-right: 1px solid #e3e3e3"
                dense
                :show-select="showSelect"
                hide-default-footer
                item-key="id"
                :mobile-breakpoint="0"
              >
                <template v-slot:item="{ item, index, isSelected, select }">
                  <entrepot-table-row
                    :item="item"
                    :index="index"
                    :item-index="items.indexOf(item)"
                    :row-number="parseInt(items.indexOf(item)) + parseInt(from)"
                    :type="type"
                    :entrepot="entrepot"
                    :cost-managament="costManagament"
                    :options="options"
                    :columns="showHeaders"
                    :locked-columns="['actions', 'row', 'product']"
                    :is-selected="isSelected"
                    @toggle-select="select"
                    @open-cost-dialog="openCostDialog"
                    @open-cost-list-dialog="openCostListDialog"
                    @open-serial-dialog="openSerialDialog"
                    @open-delete-dialog="openDeleteDialog"
                    @check-product="checkProduct"
                    @change-unit="changeUnit"
                    @convert-unit="convertUnit"
                    @check-count="checkCount"
                    @change-entrepot="changeEntrepotAtRow"
                  />
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="ma-0 px-1 entrepot-tab-footer">
            <v-col cols="12" class="py-1 px-0 d-flex align-center">
              <v-btn
                v-if="!id"
                color="primary"
                dense
                height="28"
                class="mr-0"
                :loading="isLoading"
                @click="create"
              >
                {{ $t("submit") }}
              </v-btn>
              <v-btn
                v-if="id"
                color="primary"
                dense
                height="28"
                class="mr-0"
                :loading="isLoading"
                @click="update"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
          </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item class="app-form-documents-tab entrepot-documents-tab">
          <div class="app-form-body">
            <v-container class="app-form-container app-form-documents pt-3 pb-2">
              <form-attachment-doc
                ref="refFilePicker"
                v-model="attachments"
                type-prop="entrepot"
                :val="id && attachments ? attachments : null"
              />
            </v-container>
          </div>
          <v-row class="ma-0 px-1 entrepot-tab-footer">
            <v-col cols="12" class="py-1 px-0 d-flex align-center">
              <v-btn
                v-if="!id"
                color="primary"
                dense
                height="28"
                class="mr-0"
                :loading="isLoading"
                @click="create"
              >
                {{ $t("submit") }}
              </v-btn>
              <v-btn
                v-if="id"
                color="primary"
                dense
                height="28"
                class="mr-0"
                :loading="isLoading"
                @click="update"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </v-form>
    <!-- Shared dialogs live on EntrepotIndex shell (desktop + mobile). -->
  </v-card>
</template>

<script>
export default {
  name: "EntrepotDesktopView",
};
</script>

<style>
.entrepot-form-tabs:not(.v-tabs--vertical) > .v-tabs-bar {
  height: 48px !important;
  flex: 0 0 auto;
}
.entrepot-form-tabs:not(.v-tabs--vertical) .v-tab {
  height: 48px !important;
  min-height: 48px !important;
  white-space: nowrap;
}
.entrepot-form-tabs:not(.v-tabs--vertical) .v-tabs-slider-wrapper {
  bottom: 0 !important;
}
.entrepot-main-tab {
  height: calc(100vh - 189px);
  min-height: calc(100vh - 189px);
  max-height: calc(100vh - 189px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.entrepot-main-tab__body {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.entrepot-main-tab__body > .input-minimal {
  flex: 0 0 auto;
}
/* Dense header: keep error border, hide message text so it does not sit on labels. */
.entrepot-main-tab .input-minimal .v-text-field__details {
  display: none !important;
  min-height: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.entrepot-main-tab .input-minimal .v-messages {
  display: none !important;
  min-height: 0 !important;
}
/* Keep draft icon aligned to the outlined description field (not floating outside). */
.entrepot-main-tab .entrepot-desc-col {
  position: relative;
}
.entrepot-main-tab .entrepot-desc-field.v-textarea,
.entrepot-main-tab .entrepot-desc-field {
  position: relative;
}
.entrepot-main-tab .entrepot-desc-field .v-input__control,
.entrepot-main-tab .entrepot-desc-field .v-input__slot {
  min-height: 28px !important;
  height: 28px !important;
  align-items: center !important;
}
.entrepot-main-tab .entrepot-desc-field .v-input__append-outer {
  margin: 0 !important;
  margin-inline-start: 4px !important;
  align-self: center !important;
  padding: 0 !important;
}
.entrepot-main-tab .entrepot-desc-field .v-input__append-outer .v-btn {
  margin: 0 !important;
}
.entrepot-main-tab .entrepot-desc-field .v-label:not(.v-label--active) {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
.entrepot-main-tab .entrepot-desc-field .v-label--active {
  top: 10px !important;
  transform: translateY(-18px) scale(0.75) !important;
}
.entrepot-main-tab__table-row {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
.entrepot-main-tab__table-col {
  display: flex !important;
  flex-direction: column;
  min-height: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden;
}
.entrepot-main-tab__table-col > .v-data-table {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  margin-bottom: 7px;
}
.entrepot-main-tab__table-col > .v-data-table .v-data-table__wrapper {
  height: 100% !important;
  max-height: 100% !important;
  overflow-y: auto !important;
}
.entrepot-tab-footer {
  position: relative;
  z-index: 3;
  flex: 0 0 auto;
  background: #fff;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  margin-bottom: 0 !important;
  border-top: 1px solid #e8e8e8;
}
</style>